import { AodRun, AodRunStatusEnum } from '@app/modules/audit/modules/aod/aod.types';
import {
  AuditReportsCompletedStatusDataDtoReasonEnum,
  AuditReportsCompletedStatusDataDtoReasonEnumKey,
} from '@mi-front/api-v2';

/**
 * Completion reasons stored on `statusData.completedWithoutExport.reason`.
 * Sourced from api-v2 OpenAPI types.
 */
export const AodRunCompletionReason = AuditReportsCompletedStatusDataDtoReasonEnum;

export type AodRunCompletionReasonKey = AuditReportsCompletedStatusDataDtoReasonEnumKey;

type CompletedWithoutExportWithReason = {
  reason?: AodRunCompletionReasonKey;
  comment?: string;
};

/**
 * Reads the structured completion reason from a run completed without export.
 */
export function getAodRunCompletionReason(run: AodRun): AodRunCompletionReasonKey | undefined {
  if (run.status !== AodRunStatusEnum.COMPLETED_WITHOUT_EXPORT) {
    return undefined;
  }

  const completedWithoutExport = run.statusData?.completedWithoutExport as
    | CompletedWithoutExportWithReason
    | undefined;

  return completedWithoutExport?.reason;
}

/**
 * True when the run finished without export because unmatched schedules lack spot media.
 */
export function isAodRunMissingMaterialsCompletion(run: AodRun): boolean {
  return getAodRunCompletionReason(run) === AodRunCompletionReason.MISSING_MATERIALS;
}

/**
 * Comment stored alongside completedWithoutExport status data, when present.
 */
export function getAodRunCompletionComment(run: AodRun): string | undefined {
  if (run.status !== AodRunStatusEnum.COMPLETED_WITHOUT_EXPORT) {
    return undefined;
  }

  const completedWithoutExport = run.statusData?.completedWithoutExport as
    | CompletedWithoutExportWithReason
    | undefined;

  return completedWithoutExport?.comment;
}
